var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "#FFF",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.53 11.47a.754.754 0 0 0-1.06 0l-5.72 5.72V5c0-.41-.34-.75-.75-.75s-.75.34-.75.75v12.19l-5.72-5.72c-.29-.29-.77-.29-1.06 0s-.29.77 0 1.06l7 7a.78.78 0 0 0 .53.22.75.75 0 0 0 .53-.22l7-7c.29-.29.29-.77 0-1.06"
})));
export default SvgArrowDown;